/** Firm-wide Timekeepers, Matters, Ratios and browser-local Goals. */

import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from "@/shared/components/ui/tabs";
import GoalsTab from "../components/reports/GoalsTab";
import MattersTab from "../components/reports/MattersTab";
import RatiosTab from "../components/reports/RatiosTab";
import TimekeepersReportTab from "../components/reports/TimekeepersReportTab";
import { useGoals } from "../hooks/useReportsData";
import styles from "./AdminViews.module.css";

// Matches AdminDashboardView so the two surfaces read as one system.
const tabTriggerClass =
	"rounded-none border-b-2 border-transparent bg-transparent px-3 pb-2.5 pt-2 text-sm font-medium text-muted-foreground shadow-none transition-none data-[state=active]:border-b-primary data-[state=active]:bg-transparent data-[state=active]:text-foreground data-[state=active]:shadow-none";

export default function ReportsView() {
	const { goals, stored, updateGoal, resetAll } = useGoals();

	return (
		<div className={`${styles.adminViewWrapper} flex flex-col h-full`}>
			<div className="mb-6">
				<h1 className="text-2xl font-semibold text-foreground">Reports</h1>
			</div>

			<Tabs defaultValue="timekeepers" className="flex-1">
				<TabsList className="bg-transparent rounded-none border-b border-border w-full justify-start gap-2 p-0 h-auto">
					<TabsTrigger value="timekeepers" className={tabTriggerClass}>
						Timekeepers
					</TabsTrigger>
					<TabsTrigger value="unbilled" className={tabTriggerClass}>
						Matters
					</TabsTrigger>
					<TabsTrigger value="ratios" className={tabTriggerClass}>
						Ratios
					</TabsTrigger>
					<TabsTrigger value="goals" className={tabTriggerClass}>
						Goals
					</TabsTrigger>
				</TabsList>

				<TabsContent value="timekeepers" className="mt-6">
					<TimekeepersReportTab goals={goals} />
				</TabsContent>

				<TabsContent value="unbilled" className="mt-6">
					<MattersTab />
				</TabsContent>

				<TabsContent value="ratios" className="mt-6">
					<RatiosTab />
				</TabsContent>

				<TabsContent value="goals" className="mt-6">
					<GoalsTab
						goals={goals}
						stored={stored}
						onUpdate={updateGoal}
						onResetAll={resetAll}
					/>
				</TabsContent>
			</Tabs>
		</div>
	);
}
